import { useEffect } from 'react';

const useWindowEventListener = (type, callback) =>
    useEffect(() => {
        window.addEventListener(type, callback);
        return () => window.removeEventListener(type, callback);
    }, [type, callback]);

export default useWindowEventListener;
